import { createAction, props } from '@ngrx/store';
import { ContactUsRequestModel } from 'src/app/model/request/contact.us.request.model';
import { ExistingSuggestRouteRequestModel, SuggestRouteRequestModel } from 'src/app/model/request/suggest.route.request.model';

export const suggestRoute = createAction(
  '[Suggest Route] Create Suggest Route',
  props<{ request: SuggestRouteRequestModel }>()
);

export const suggestRouteFailure = createAction(
  '[Suggest Route] Suggest Route Failure',
  props<{ error: any }>()
);

export const suggestRouteSuccess = createAction(
  '[Suggest Route] Suggest Route Success',
  props<{ response: any }>()
);


export const existingSuggestRoute = createAction(
  '[Existing Suggest Route] Create Suggest Route',
  props<{ request: ExistingSuggestRouteRequestModel }>()
);

export const existingSuggestRouteFailure = createAction(
  '[Existing Suggest Route] Suggest Route Failure',
  props<{ error: any }>()
);

export const existingSuggestRouteSuccess = createAction(
  '[Existing Suggest Route] Suggest Route Success',
  props<{ response: any }>()
);


export const contactUs = createAction(
  '[Contact Us] Contact Us',
  props<{ request: ContactUsRequestModel }>()
);

export const contactUsFailure = createAction(
  '[Contact Us] Contact Us Failure',
  props<{ error: any }>()
);

export const contactUsSuccess = createAction(
  '[Contact Us] Contact Us Success',
  props<{ response: any }>()
);
